// axios
import axios from 'axios'
import themeConfig from '../themeConfig'

const domain = themeConfig.API_URL
import store from "./store/store"

export default axios.create({
  baseURL: domain,
  // You can add your headers here
  headers:{
    'Content-Type': 'application/x-www-form-urlencoded',
    'Accept' : 'application/json',
    'X-Requested-With' : 'XMLHttpRequest',
    'Authorization' : store.state.api_token
  }
})
